import { render, staticRenderFns } from "./Aceptacion.vue?vue&type=template&id=7e258ba2&"
import script from "./Aceptacion.vue?vue&type=script&lang=js&"
export * from "./Aceptacion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports